/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { createBrowserHistory } from 'history';
import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { apiSlice } from './apiSlice';

import authReducer from './auth/authSlice';
import botsReducer from './bots/botsSlice';
import mediaFilesReducer from './media/mediaSlice';
import knowledgeBasesReducer from './knowledgeBases/knowledgeBasesSlice';
import globalReducer from './global/globalSlice';
import livechatReducer from './liveChat/liveChatSlice';
import notificationReducer from './notifications/notificationsSlice';
import { setupListeners } from '@reduxjs/toolkit/dist/query';

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory() });

const rootReducer = combineReducers({
  auth: authReducer,
  bots: botsReducer,
  global: globalReducer,
  livechat: livechatReducer,
  notifications: notificationReducer,
  mediaFiles: mediaFilesReducer,
  knowledgeBases: knowledgeBasesReducer,
  router: routerReducer,
  [apiSlice.reducerPath]: apiSlice.reducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat([routerMiddleware, apiSlice.middleware])
});

export const history = createReduxHistory(store);

setupListeners(store.dispatch);

export default store;
